import { kebabCase } from 'lodash';

type TNotificationSource = { source_entity_name?: string; source_entity_id?: string };

/** Talent manager notices (the API's TalentManagerNotice) and the page each opens */
const TALENT_MANAGER_PAGES: Record<string, string> = {
  tmProfile: '/talent-manager?tab=profile',
  tmEngagement: '/talent-manager?tab=engagements',
  tmEarnings: '/talent-manager?tab=earnings',
  tmApplication: '/admin',
};

/**
 * The page a notification opens, or null when it has none. Most are about something in the current
 * project; talent manager notices go to their own pages, and "time logged" to the project it names.
 */
export const notificationLink = (
  n: TNotificationSource,
  { currentProjectName, projects = [] }: { currentProjectName?: string; projects?: { id: string; name: string }[] }
): string | null => {
  const { source_entity_name: entity, source_entity_id: id } = n;
  if (!entity) return null;
  if (TALENT_MANAGER_PAGES[entity]) return TALENT_MANAGER_PAGES[entity];
  if (entity === 'tmProjectTime') {
    const project = projects.find((p) => p.id === id);
    return project ? `/project/${kebabCase(project.name)}/talent-manager` : null;
  }
  if (!id || !currentProjectName) return null;
  return `/project/${kebabCase(currentProjectName)}/${entity.toLocaleLowerCase()}/${id}`;
};
